module.exports = __webpack_public_path__ + "static/media/logo_lettering.d5bb7cdb.svg";